import { createHttpClient } from "./http";

export class EntradaProdutoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async save(data) {
		try {
			const result = await this.axios.post("entrada-produto", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar entrada de produto.");
		}
	}

	async update(data) {
		try {
			const result = await this.axios.put("entrada-produto", data, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao atualizar entrada de produto.");
		}
	}

	async remover(id) {
		try {
			const result = await this.axios.delete(`entrada-produto/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao excluir entrada.");
		}
	}

	async getHistorico(id) {
		try {
			const result = await this.axios.get(`entrada-produto/${id}/historico`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar histórico da entrada.");
		}
	}

	async getRecepcao(unidadeDistribuidoraId, data, page = 1, limit = 10, search = "") {
		try {
			const params = { unidadeDistribuidoraId, data, page, limit };
			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("entrada-produto/recepcao", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar recepção.");
		}
	}

	async getConsolidado(unidadeDistribuidoraId, data, page = 1, limit = 10, search = "") {
		try {
			const params = { unidadeDistribuidoraId, data, page, limit };
			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("entrada-produto/consolidado", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar consolidado.");
		}
	}

	async getById(id) {
		try {
			const result = await this.axios.get(`entrada-produto/${id}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");
			if(error.response?.status === 404)
				throw new Error("Entrada não encontrada.");

			throw new Error(error.message || "Erro ao carregar entrada.");
		}
	}

	async confirmarEntrada(id) {
		try {
			const result = await this.axios.put(`entrada-produto/${id}/confirmar`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao confirmar entrada.");
		}
	}

	async negarEntrada(id) {
		try {
			const result = await this.axios.put(`entrada-produto/${id}/negar`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao negar entrada.");
		}
	}

	async salvarQualidades(id, qualidades) {
		try {
			const result = await this.axios.put(`entrada-produto/${id}/qualidades`, { qualidades }, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
					"Content-Type": "application/json",
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao salvar qualidades.");
		}
	}

	async changeVisibility(id) {
		try {
			const result = await this.axios.put(`entrada-produto/${id}/change-visibility`, null, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error("Erro ao alterar visibilidade da entrada.");
		}
	}

	async getProdutosEntrada(unidadeDistribuidoraId) {
		try {
			const result = await this.axios.get(`entrada-produto/produtos/${unidadeDistribuidoraId}`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar produtos de entrada.");
		}
	}

	async getQualidades() {
		try {
			const result = await this.axios.get("entrada-produto/qualidades", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar qualidades.");
		}
	}

	async getLotesConsolidados(unidadeDistribuidoraId, produtoId) {
		try {
			const result = await this.axios.get(`entrada-produto/lotes`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params: {
					unidadeDistribuidoraId,
					produtoId
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar lotes.");
		}
	}

	async getFornecedoresPorProduto(unidadeDistribuidoraId, cultivoId) {
		try {
			const result = await this.axios.get(`entrada-produto/fornecedores-por-produto`, {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params: {
					unidadeDistribuidoraId,
					cultivoId
				}
			});

			return result.data;
		} catch (error) {
			if(error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.message || "Erro ao carregar fornecedores por produto.");
		}
	}
}
